import {Notification} from 'element-ui'

export default {
  error(msg, title = "错误") {
    if (typeof msg === "object") {
      msg = msg.message
    }
    Notification({
      title,
      message: msg,
      type: 'error'
    });
  }

  , warning(msg, title = "警告") {
    if (typeof msg === "object") {
      msg = msg.message
    }
    Notification({
      title,
      message: msg,
      type: 'warning'
    });
  }

  , success(msg, title = "成功") {
    if (typeof msg === "object") {
      msg = msg.message
    }
    Notification({
      title,
      message: msg,
      type: 'success'
    });
  }
}
